import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {Container, Grid} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import {InputRow} from "../index";
import {onChangeInput} from "../../services/utils";
import {expiryOfferOption} from "../../environment";

const useStyles = makeStyles((theme) => ({
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // backgroundColor:'orange',
    overflow: 'auto'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: 10,
    borderRadius: 20
  },
  content: {
    padding: theme.spacing(4, 15, 5, 15),
    // backgroundColor:'gray'
  }
}));

const Label = (title) => {
  return (
    <p className='black-color mt-20 font-12 mb-0 text-uppercase'>{title}</p>

  )
}
export default function MakeOfferModal(props) {
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);
  // const {open, setOpen, state: {values, errors}, setState} = props
  const {open, setOpen, state, setState} = props
  const {values, errors} = state
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}

        open={open}
        onClose={handleClose}
        // closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          // timeout: 500,
        }}
      >
        <Fade in={open}>
          <Container component="main" maxWidth="md" style={{paddingTop: 40, overflow: 'auto'}}>
            <div className={classes.paper}>
              <p className=' width-max-content float-right mouse-pointer pt-10 pr-20 font-18 error-class'
                 onClick={() => {
                   handleClose()
                 }}
              >X</p>
              <div className={classes.content}>
                <h1>Record Your Interest</h1>
                {/*{Label('offer expiry')}*/}
                <InputRow
                  types={[
                    {
                      type: 'select',
                      value: values.searchType,
                      // error: errors.priceUnit,
                      id: 'searchType',
                      label: 'search Type',
                      dropdownList: [{text: 'Product', value: 'product'}, {text: 'service ', value: 'service'},]
                    }, {
                      value: values.searchCategory,
                      // error: errors.priceUnit,
                      id: 'searchCategory',
                      label: 'search Category',
                    }, {
                      value: values.searchSubCategory,
                      // error: errors.priceUnit,
                      id: 'searchSubCategory',
                      label: 'search Sub-Category',
                    },
                    {
                      type: 'select',
                      value: values.country,
                      // error: errors.priceUnit,
                      label: 'country',
                      dropdownList: expiryOfferOption
                    },
                    {
                      type: 'select',
                      value: values.state,
                      // error: errors.priceUnit,
                      label: 'state',
                      dropdownList: expiryOfferOption
                    },
                    {
                      type: 'select',
                      value: values.city,
                      // error: errors.priceUnit,
                      label: 'city',
                      dropdownList: expiryOfferOption
                    },
                    {
                      type: 'number',
                      min: 1,
                      value: values.priceFrom,
                      // error: errors.priceUnit,
                      id: 'priceFrom',
                      label: 'price From',
                    },
                    {
                      type: 'number',
                      min: 1,
                      value: values.priceTo,
                      // error: errors.priceUnit,
                      id: 'priceTo',
                      label: 'price To',
                    },
                    {
                      value: values.currency,
                      // error: errors.priceUnit,
                      label: 'currency',
                    },
                    {
                      type: 'number',
                      min: 1,
                      value: values.qty,
                      // error: errors.priceUnit,
                      label: 'qty',
                    },
                    {
                      type: 'number',
                      min: 1,
                      value: values.qtyName,
                      // error: errors.priceUnit,
                      id: 'qtyName',
                      label: 'qty Name',
                    },
                    {
                      type: 'select',
                      min: 1,
                      value: values.unit,
                      // error: errors.priceUnit,
                      label: 'Unit',
                      dropdownList: expiryOfferOption
                    },
                    {
                      type: 'number',
                      value: values.estimatedROI,
                      // error: errors.priceUnit,
                      id: 'estimatedROI',
                      label: 'estimated ROI(%)',
                    },
                    {
                      type: 'date',
                      value: values.investmentClosingDate,
                      // error: errors.priceUnit,
                      id: 'investmentClosingDate',
                      label: 'investment Closing Date',
                    },
                    {
                      type: 'date',
                      value: values.investmentReturnDate,
                      // error: errors.priceUnit,
                      id: 'investmentReturnDate',
                      label: 'investment Return Date',
                    },

                    {
                      type: 'select',
                      value: values.clousreStatus,
                      // error: errors.priceUnit,
                      id: 'clousreStatus',
                      label: 'clousre Status',
                      dropdownList: [
                        {text: 'open', value: 'open'},
                        {text: 'close ', value: 'close'},
                        {text: 'UNKNOWN', value: 'UNKNOWN'},
                      ]
                    },
                    {
                      type: 'number',
                      value: values.minimumShare,
                      // error: errors.priceUnit,
                      id: 'minimumShare',
                      label: 'minimum Share',
                    },
                    {
                      type: 'number',
                      value: values.sharedQty,
                      // error: errors.priceUnit,
                      id: 'sharedQty',
                      label: 'Share Qty',
                    },
                    {
                      type: '',
                      value: values.shareCurrency,
                      // error: errors.priceUnit,
                      id: 'shareCurrency',
                      label: 'shareCurrency',
                    },
                    {
                      type: 'file',
                      value: values.image?.name ?? '',
                      // error: errors.file,
                      label: 'Product Image',
                      id: 'image',
                      accept: 'image/*'
                    },
                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={3}
                />

                {/*{Label('message for the seller')}*/}
                <div className='display-flex align-items-center mt-20'>
                  <InputRow
                    types={[
                      // {value: values.city, error: errors.city, label: 'region'},
                      {
                        type: '',
                        value: values.preferedMethod,
                        // error: errors.priceUnit,
                        id: 'preferedMethod',
                        label: 'preferred Method',
                        placeholder: 'preferred contact Method & time',
                        multiline: true
                      },
                      {
                        type: '',
                        value: values.details,
                        // error: errors.priceUnit,
                        placeholder: 'Add more details you want to provide',
                        multiline: true,
                        id: 'details',
                        label: 'details',
                      },

                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={2}
                  />
                </div>
                <div className='display-flex  flex-column  checkout-container mt-30 mb-20'>
                  <button
                    className=' add-cart-btn-small display-flex justify-content-center  bg-green border-none white-color text-center'
                    style={{minWidth: 220}}
                    onClick={(e) => props.makeOffer(e)}
                  > Record Interest
                  </button>
                </div>
              </div>
            </div>
          </Container>
        </Fade>
      </Modal>
    </div>
  );
}
